import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Response} from '@angular/http';

import {NgbActiveModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AlertService, EventManager, JhiLanguageService} from 'ng-jhipster';

import {Campagne} from './campagne.model';
import {CampagnePopupService} from './campagne-popup.service';
import {CampagneService} from './campagne.service';

import {Formation, FormationService} from '../formation';

@Component({
    selector: 'jhi-campagne-formations-dialog',
    templateUrl: './campagne-formations-dialog.component.html'
})
export class CampagneFormationsDialogComponent implements OnInit {

    campagne: any;
    campagnes: Campagne[] = [];
    formationListe: Formation[];
    filteredList: Formation[];
    selectedFormations = [];
    isSaving: boolean;
    private lastRowIndex: number;

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private formationService: FormationService,
        private campagneService: CampagneService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['campagne', 'commission']);
    }

    ngOnInit() {
        this.isSaving = true;
        let pasCampagneId: Number = null;
        if (this.campagne instanceof Array) {
            this.campagnes = this.campagne;
        } else {
            this.campagnes.push(new Campagne(this.campagne.id));
            pasCampagneId = this.campagne.id;
        }

        this.formationService.query({
            supprimee: false,
            pasCampagneId: pasCampagneId
        }).subscribe(
            (res: Response) => {
                this.isSaving = false;
                this.formationListe = res.json();
                this.assignCopy();
            },
            (res: Response) => {
                this.isSaving = false;
                this.onError(res);
                this.isSaving = false;
            }
        );
    }
    clear () {
        this.activeModal.dismiss('cancel');
    }

    save () {
        this.isSaving = true;
        // Rattacher les formations sélectionnées aux campagnes sélectionnées
        this.campagnes.forEach(campagne => {
            campagne.formations = this.selectedFormations;
        });
        this.campagneService.updateFormations(this.campagnes).subscribe(
            res => {
                this.onSaveSuccess(res);
            },
            (res: Response) => this.onSaveError(res.json())
        );
    }

    assignCopy() {
        this.filteredList = Object.assign([], this.formationListe);
    }

    filterFormations (value) {
        if (!value) { // when empty
            this.assignCopy();
        }
        this.filteredList = Object.assign([], this.formationListe).filter(
            item => item.libelle.toLowerCase().indexOf(value.toLowerCase()) > -1
        );
    }

    selectFormation(event, formation, index) {
        // In popup Rattacher des formations, selections des formations!
        if (event.shiftKey && this.lastRowIndex > -1 && this.lastRowIndex !== index) {
            // Si l'utilisateur a appuyé sur la touche SHIFT, sélectionner toutes les formations entre les 2 index!
            if (this.lastRowIndex < index) {
                for (let i = this.lastRowIndex + 1; i <= index; i++) {
                    this.addSelectedFormation(this.filteredList[i], i);
                }
            } else if (this.lastRowIndex > index) {
                for (let i = this.lastRowIndex - 1; i >= index; i--) {
                    this.addSelectedFormation(this.filteredList[i], i);
                }
            }
        } else {
            this.addSelectedFormation(formation, index);
            this.lastRowIndex = index;
        }
    }

    /**
     * Si la formation a deja un ID, l'ajouter à la liste des formations sélectionnées
     * Sinon il faut la créer dans la table formation avant de l'ajouter
     * @param formation sélectionnée
     * @param index de la formation dans la liste
     */
    private addSelectedFormation(formation, index) {
        if (formation.id) {
            this.pushToSelectedFormations(formation.id);
        } else {
            this.formationService.create(formation).subscribe(ff => {
                this.filteredList[index] = ff;
                this.pushToSelectedFormations(ff.id);
            });
        }
    }

    /**
     * Sélectionner / Déselectionner une formation dans la liste
     * @param id de la formation
     */
    private pushToSelectedFormations(id) {
        if (this.selectedFormations.indexOf(id) < 0) {
            this.selectedFormations.push(id);
        } else {
            this.selectedFormations.splice(this.selectedFormations.indexOf(id), 1);
        }
    }

    private onSaveSuccess (result: Campagne[]) {
        this.eventManager.broadcast({ name: 'campagneFormationsModification', content: result});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError (error) {
        this.isSaving = false;
        this.onError(error);
    }

    private onError (error) {
        this.alertService.error(error.message, null, null);
    }
}

@Component({
    selector: 'jhi-campagne-formations-popup',
    template: ''
})
export class CampagneFormationsPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private campagnePopupService: CampagnePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            let campagnes = params['campagnes'];
            this.modalRef = this.campagnePopupService
                    .open(CampagneFormationsDialogComponent, campagnes);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/campagne/campagne-formations-dialog.component.ts